import { createSlice } from '@reduxjs/toolkit';
import { unique_value } from '../util/unique';
export function isOutletKind(s) {
    return s == 'onoff' || s == 'dim' || s == 'rollershade';
}
export const initialState = {
    id: null,
    title: '',
    kind: 'onoff',
    codes: [],
    comment: ''
};
const slice = createSlice({
    name: 'edit_outlet_dialog',
    initialState,
    reducers: {
        setEditOutletDialog(state, action) {
            state.id = action.payload.id;
            state.title = action.payload.title;
            state.kind = action.payload.kind;
            state.codes = action.payload.codes;
            state.comment = action.payload.comment;
        },
        setEditOutletDialogTitle(state, action) {
            state.title = action.payload;
        },
        setEditOutletDialogKind(state, action) {
            state.kind = action.payload;
        },
        setEditOutletDialogComment(state, action) {
            state.comment = action.payload;
        },
        setEditOutletDialogCodeDeleteItem(state, action) {
            state.codes.splice(action.payload, 1);
        },
        setEditOutletDialogCodeAddItem(state) {
            state.codes.push({ key: unique_value(), code: undefined, unit: undefined });
        },
        setEditOutletDialogCodeValue(state, action) {
            state.codes[action.payload.index].code = action.payload.code;
        },
        setEditOutletDialogCodeUnit(state, action) {
            state.codes[action.payload.index].unit = action.payload.unit;
        },
    }
});
export const { setEditOutletDialog, setEditOutletDialogTitle, setEditOutletDialogKind, setEditOutletDialogComment, setEditOutletDialogCodeDeleteItem, setEditOutletDialogCodeAddItem, setEditOutletDialogCodeValue, setEditOutletDialogCodeUnit, } = slice.actions;
export const edit_outlet_dialog = slice.reducer;
